module.exports = __webpack_public_path__ + "img/y_2025_hover.e1aa3b0b.png";